import Grid from '@material-ui/core/Grid';
import Modal from 'components/CncUI/Modal';
import Button from 'components/CncUI/Button';

const DeleteModal = props => {
  const { show, type, onClose, onDelete } = props;

  return (
    <Modal open={show} maxWidth={400}>
      <Modal.Title>Remove {type}</Modal.Title>
      <Modal.Content>
        <Modal.ContentText>
          {type === 'bank'
            ? `Are you sure you want to remove this bank from your direct deposit
        profile?`
            : `Are you sure you want to remove this active direct deposit
        account? By removing it, you will no longer receive direct deposit
        payments to this account.`}
        </Modal.ContentText>
      </Modal.Content>
      <Modal.Actions>
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button secondary onClick={onClose}>
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button danger onClick={onDelete}>
              Yes, Remove
            </Button>
          </Grid>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteModal;
